// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";
import { ImageFader } from "../../../components/image_fader/ImageFader";
import { ScrollIndicator } from "../../../components/scroll_indicator/ScrollIndicator";
import { Api } from "../../../api";
import { ModelSerie } from "../../../common/interfaces/conversionworld/RequestFilter";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
    ImageFader,
    ScrollIndicator,
  },
})
export class StageFallbackFrontpageModule extends ModuleBase {
  private currentIndex = 0;
  private currentImage: string = "";
  private currentMobileImage: string = "";
  private timer: number | null = null;
  private count: number = 0;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  async created() {
    let products = await Api.conversionWorldService.getProducts(
      {
        page_id: this.$store.page.page!.id,
        query: "",
        branchen: [],
        countries: [],
        solutions: [],
        model_series: [],
        bodybuilder: [],
      },
      "both",
      undefined,
      1
    );

    this.count = products.pagination!.total_count!;
  }

  mounted() {
    this.fadeLoop();

    // Preload images
    this.imageData.map((i) => {
      new Image().src = i.src;
    });
  }

  get imageData() {
    return this.instance["images"].map((i) => {
      return {
        src: this.getTranslatedImage(i["image"], this.lang, "xlarge"),
        duration: i["duration"],
      };
    });
  }

  get imageDataMobile() {
    if (
      this.instance["images_mobile"] &&
      this.instance["images_mobile"].length > 0
    ) {
      return this.instance["images_mobile"].map((i) => {
        return {
          src: this.getTranslatedImage(i["image"], this.lang, "xlarge"),
          duration: i["duration"],
        };
      });
    }

    return this.imageData;
  }

  private fadeLoop() {
    if (this.currentIndex >= this.imageData.length) {
      this.currentIndex = 0;
    }
    this.currentImage = this.imageData[this.currentIndex].src;
    if (
      this.imageDataMobile[this.currentIndex] &&
      this.imageDataMobile[this.currentIndex].src
    ) {
      this.currentMobileImage = this.imageDataMobile[this.currentIndex].src;
    } else {
      this.currentMobileImage = this.imageData[this.currentIndex].src;
    }
    let duration =
      this.imageData[this.currentIndex].duration ||
      this.imageDataMobile[this.currentIndex].duration;

    this.timer = <any>setTimeout(() => {
      this.currentIndex = this.getNextIndex();
      if (this.currentIndex == 0 || this.currentIndex > 0) {
        this.fadeLoop();
      }
    }, duration * 1000);
  }

  private getNextIndex() {
    let next = this.currentIndex + 1;
    if (next > this.imageData.length - 1) {
      next = 0;
    }

    return next;
  }
}
